// Half Term 20: keeps department statuses, countdowns and card prices in step with the clock.
// Config and helpers come from snippets/ht20-config.liquid.
(() => {
  const h = window.ht20;
  if (!h) return;
  const root = document.documentElement;
  const setText = (el, text) => { if (el.textContent !== text) el.textContent = text; };
  const panelPrices = new WeakMap();

  // Product page panel: follow the selected variant (same lookup as the Big Surf panel).
  const syncPanels = () => {
    document.querySelectorAll('[data-ht20-pdp]').forEach(panel => {
      let prices = panelPrices.get(panel);
      if (!prices) {
        try { prices = JSON.parse(panel.querySelector('[data-ht20-variants]').textContent); }
        catch (_) { return; }
        panelPrices.set(panel, prices);
      }
      let scope = panel.parentElement;
      while (scope && scope !== document.body && !scope.querySelector('form[action*="/cart/add"]')) scope = scope.parentElement;
      if (!scope || scope === document.body) return;
      const field = scope.querySelector('form[action*="/cart/add"] [name="id"]');
      const selected = field && prices[field.value];
      if (!selected) return;
      setText(panel.querySelector('[data-ht20-final]'), selected[0]);
      setText(panel.querySelector('[data-ht20-was]'), selected[1]);
    });
  };

  const tick = () => {
    const live = h.live();
    root.classList.toggle('ht20-on', live);
    if (!live) return;
    const now = h.now();

    // Department chips: closed, closing tonight (with countdown) or open until a later day.
    document.querySelectorAll('[data-ht20-dept]').forEach(chip => {
      const ends = chip.dataset.ht20Ends;
      const closed = now >= Date.parse(ends);
      const status = h.when(ends);
      chip.classList.toggle('is-closed', closed);
      chip.classList.toggle('is-tonight', status === 'Closes tonight');
      const label = chip.querySelector('[data-ht20-status]');
      if (label) setText(label, status === 'Closes tonight' ? 'Closes in ' + h.left(ends) : status);
      if (closed && chip.tagName === 'A') chip.removeAttribute('href');
    });

    // "Next to close" line: the department(s) with the earliest closing time still ahead.
    const open = h.depts.filter(d => d.end > now);
    const next = open.length ? Math.min(...open.map(d => d.end)) : 0;
    const names = open.filter(d => d.end === next).map(d => d.label);
    let nextText = '';
    if (names.length) {
      const nextIso = new Date(next).toISOString();
      const status = h.when(nextIso);
      nextText = names.join(', ').replace(/, ([^,]*)$/, ' & $1') + (names.length > 1 ? ' close' : ' closes') +
        (status === 'Closes tonight' ? ' in ' + h.left(nextIso) : ' on ' + status.replace('Until ', ''));
    }
    document.querySelectorAll('[data-ht20-next]').forEach(el => setText(el, nextText));

    // Product cards: hide once the product's department has closed.
    document.querySelectorAll('[data-ht20-card]').forEach(card => {
      const ends = card.dataset.ht20Ends;
      card.hidden = now >= Date.parse(ends);
      const when = card.querySelector('[data-ht20-when]');
      if (when && !card.hidden) setText(when, h.when(ends) === 'Closes tonight' ? 'Closes in ' + h.left(ends) : h.when(ends));
    });

    // Product page panel: countdown tiles, hidden once the department has closed.
    // Days only show with more than 24 hours to go; screen readers get the closing time in words instead of ticking digits.
    document.querySelectorAll('[data-ht20-pdp]').forEach(panel => {
      const ends = panel.dataset.ht20Ends;
      panel.hidden = now >= Date.parse(ends);
      if (panel.hidden) return;
      const status = h.when(ends);
      const name = panel.querySelector('.ht20-pdp__when strong');
      const when = panel.querySelector('[data-ht20-pdp-when]');
      if (when) setText(when, (name ? name.textContent + ' ' : '') + 'discounts close ' +
        (status === 'Closes tonight' ? 'tonight' : status.replace('Until ', 'on ')) + ' at 23:59 UK time.');
      const s = Math.max(0, Math.floor((Date.parse(ends) - now) / 1000));
      const days = Math.floor(s / 86400);
      const values = { days, hours: Math.floor(s / 3600) % 24, mins: Math.floor(s / 60) % 60, secs: s % 60 };
      panel.querySelectorAll('[data-ht20-unit]').forEach(unit => {
        const key = unit.dataset.ht20Unit;
        if (key === 'days') unit.hidden = days === 0;
        setText(unit.querySelector('b'), String(values[key]).padStart(2, '0'));
      });
    });
    syncPanels();
  };

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-ht20-copy]');
    if (!button) return;
    const status = button.parentElement.querySelector('[data-ht20-copy-status]');
    const original = button.textContent;
    try {
      await navigator.clipboard.writeText(h.code);
      button.textContent = 'Copied';
      if (status) status.textContent = h.code + ' copied to your clipboard.';
      setTimeout(() => { button.textContent = original; }, 2400);
    } catch (_) {
      if (status) status.textContent = 'Copy failed. The code is ' + h.code + '.';
    }
  });

  document.addEventListener('change', () => setTimeout(syncPanels, 0));
  tick();
  setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', tick);
  document.addEventListener('visibilitychange', tick);
})();
